import { render } from "./CustomSelect2.vue?vue&type=template&id=d021c7f4"
import script from "./CustomSelect2.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSelect2.vue?vue&type=script&setup=true&lang=js"

import "./CustomSelect2.vue?vue&type=style&index=0&id=d021c7f4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/general/CustomSelect2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d021c7f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d021c7f4', __exports__)) {
    api.reload('d021c7f4', __exports__)
  }
  
  module.hot.accept("./CustomSelect2.vue?vue&type=template&id=d021c7f4", () => {
    api.rerender('d021c7f4', render)
  })

}


export default __exports__